import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Montar Kit", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Desmontar Kit", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Criar Kit", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "ant-row",
  style: {"margin-top":"10px"}
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  class: "ant-row",
  style: {"margin-top":"10px"}
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_kits_modal = _resolveComponent("kits-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: 'Kits de Produtos',
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "1000px",
    centered: "",
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.state.abaSelecionada === 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.montarKits && _ctx.montarKits(...args)))
          }, _hoisted_2))
        : (_ctx.state.abaSelecionada === 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.desmontarKits && _ctx.desmontarKits(...args)))
            }, _hoisted_4))
          : (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.criarKit && _ctx.criarKit(...args)))
            }, _hoisted_6))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.state.abaSelecionada,
            "onUpdate:activeKey": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.abaSelecionada) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 1,
                tab: "MONTAGEM DE KITS"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_form_item, {
                        label: "Produto Kit",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_produto, {
                            codigoSelecionado: _ctx.state.produtoSelecionadoMontagem,
                            "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produtoSelecionadoMontagem) = $event)),
                            "apenas-kits": true,
                            empresas: [_ctx.props.empresa],
                            onChange: _ctx.obterItensKit
                          }, null, 8, ["codigoSelecionado", "empresas", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_form_item, {
                        label: "Estoque",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_estoque, {
                            codigoSelecionado: _ctx.state.estoqueSelecionadoMontagem,
                            "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.estoqueSelecionadoMontagem) = $event)),
                            empresas: [_ctx.props.empresa],
                            tiposEstoques: [1, 3]
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "Quantidade",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.qtdMontagem,
                            "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.qtdMontagem) = $event)),
                            onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.calcularQtdMovimento(true)))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_card, { titulo: "Itens do Kit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.state.colunasMontagem.filter(item => item.visible),
                        "data-source": _ctx.state.itensMontagem,
                        rowKey: "index",
                        pagination: false,
                        scroll: { y: 200 },
                        size: "small",
                        rowClassName: "ss-table-campos"
                      }, {
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item no kit." })
                        ]),
                        bodyCell: _withCtx(({ column, text, record }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(text), 1))
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 2,
                tab: "DESMONTAGEM DE KITS"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_a_form_item, {
                        label: "Produto Kit",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_produto, {
                            codigoSelecionado: _ctx.state.produtoSelecionadoDesmontagem,
                            "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.produtoSelecionadoDesmontagem) = $event)),
                            "apenas-kits": true,
                            empresas: [_ctx.props.empresa],
                            onChange: _ctx.obterItensKit
                          }, null, 8, ["codigoSelecionado", "empresas", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Estoque",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_estoque, {
                            codigoSelecionado: _ctx.state.estoqueSelecionadoDesmontagem,
                            "onUpdate:codigoSelecionado": [
                              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.estoqueSelecionadoDesmontagem) = $event)),
                              _ctx.obterQtdDisponivel
                            ],
                            empresas: [_ctx.props.empresa],
                            tiposEstoques: [1, 3]
                          }, null, 8, ["codigoSelecionado", "empresas", "onUpdate:codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_form_item, {
                        label: "Qtd Disponível",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.qtdDisponivel,
                            "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.qtdDisponivel) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: "Quantidade",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.qtdDesmontagem,
                            "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.qtdDesmontagem) = $event)),
                            onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.calcularQtdMovimento(false)))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_card, { titulo: "Itens do Kit" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.state.colunasDesmontagem.filter(item => item.visible),
                        "data-source": _ctx.state.itensDesmontagem,
                        rowKey: "index",
                        pagination: false,
                        scroll: { y: 200 },
                        size: "small",
                        rowClassName: "ss-table-campos"
                      }, {
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item no kit." })
                        ]),
                        bodyCell: _withCtx(({ column, text, record }) => [
                          (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(text), 1))
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 3,
                tab: "KITS VIRTUAIS"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.state.colunasKits.filter(item => item.visible),
                    "data-source": _ctx.state.kits,
                    rowKey: "index",
                    pagination: false,
                    scroll: { y: 200 },
                    size: "small",
                    rowClassName: "ss-table-campos"
                  }, {
                    emptyText: _withCtx(() => [
                      _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum kit encontrado." })
                    ]),
                    bodyCell: _withCtx(({ column, text, record }) => [
                      (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("a", {
                                title: "Visualizar",
                                class: "visualizar",
                                onClick: ($event: any) => (_ctx.editarKit(record.codigo))
                              }, [
                                _createVNode(_component_icone, { nome: "visualizar" })
                              ], 8, _hoisted_22),
                              _createElementVNode("a", {
                                title: "Excluir",
                                onClick: ($event: any) => (_ctx.excluirKit(record)),
                                class: "excluir"
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_23)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(text), 1))
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source"])
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
          _createVNode(_component_kits_modal, {
            visivel: _ctx.state.exibirModalKit,
            "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.exibirModalKit) = $event)),
            empresa: _ctx.props.empresa,
            codigo: _ctx.state.kitSelecionado,
            onConfirmacao: _ctx.obterKits
          }, null, 8, ["visivel", "empresa", "codigo", "onConfirmacao"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}